import { CompanyDocument, PersonalDocument } from '@scansource-brazil/zeus-core-ui/utils';

export function formatPercentage(value: unknown): string {
  if (isNaN(parseFloat(value as any))) return '-';

  return new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value) / 100);
}
export function formatCurrency(value: unknown): string {
  if (isNaN(parseFloat(value as any))) return '-';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(Number(value))
    .replace(' ', ' ');
}

export function dateStringToModel(date: unknown): string {
  if (!date || isNaN(new Date(date as any).getTime()) || date === '0001-01-01T00:00:00')
    return '-';

  return new Date(date as any).toLocaleDateString();
}

export function formatToISODate(date: Date): string {
  return date instanceof Date && !isNaN(date.getTime())
    ? date.toISOString().split('T')[0]
    : '';
}

export function adaptCustomerDocument(
  finalCustomerDocument: string | null,
): CompanyDocument | PersonalDocument | string {
  if (!finalCustomerDocument) return '';
  if (new CompanyDocument(finalCustomerDocument).isCompanyDocumentLike)
    return new CompanyDocument(finalCustomerDocument);
  if (new PersonalDocument(finalCustomerDocument).isValid)
    return new PersonalDocument(finalCustomerDocument);
  return '';
}

export function adaptFilterOption({ filterOption, filterValue }: SalesCommissionFilters) {
  if (!filterOption) return;
  if (!filterValue || filterValue === '') return;

  const filterOptionsMapper = new Map([
    ['INVOICE_NUMBER', 'invoiceNumber'],
    ['INVOICE_SERIE', 'invoiceSerieNumber'],
    ['ORDER_NUMBER', 'salesOrderNumber'],
    ['COMPANY_DOCUMENT', 'finalCustomerDocument'],
    ['FINAL_CUSTOMER_NAME', 'finalCustomerName'],
  ]);

  const filterKey = filterOptionsMapper.get(filterOption);

  if (!filterKey) {
    console.error('AdaptSalesCommissionFiltersError ->> Invalid filter option');
    return;
  }

  return {
    filteredField: filterKey,
    genericTerm: filterValue,
  };
}
